module.exports = __webpack_public_path__ + "img/华美整形.0d17b05.png";